import * as Sentry from "@sentry/react";
import { getRuntimeInfo } from "src/helpers/runtime";
import { MonitoringAdapter } from "../MonitoringAdapter";
import environment from "src/constants/environment";
import { detectDeviceInfo } from "src/helpers/device";

let initialized = false;

export const sentryAdapter: MonitoringAdapter = {
  init() {
    if (initialized) return;
    initialized = true;

    Sentry.init({
      dsn: environment.SENTRY_DSN,
      environment: environment.ENV,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
    });

    const runtime = getRuntimeInfo();
    const deviceInfo = detectDeviceInfo();

    // These become global tags for all events
    Sentry.setTags({
      app_version: runtime.app_version,
      app_build_number: runtime.app_build_number,
      web_version: runtime.web_version,
      platform: runtime.platform,
      device_type: deviceInfo.device_type,
      browser: deviceInfo.browser,
    });
  },

  setUser(user) {
    try {
      Sentry.setUser(user ?? null);
    } catch (error) {
      console.error("[SentryError] Error setting user:", error);
    }
  },
};
